import { useLang } from 'hooks/lang';

import { Button, Column, Row, ComponentOrNode } from 'components/Blocks';

import { listGet } from 'utils/array';
import { REPRICE_REASONS } from 'utils/constants';

interface SelectedReasonProps {
  reason: string;
  setReason(r: string | null): void;
}

export function SelectedReason({ reason, setReason }: SelectedReasonProps) {
  const { t } = useLang();

  const { getDescription, getLabel, icon } = listGet(REPRICE_REASONS, reason, 'value')!;

  return (
    <Row gap="2" alignItems="flex-start" className="rounded-md border p-2">
      <ComponentOrNode target={icon} size={16} className="mt-1" color="primary" />

      <Column gap="1" fullWidth>
        <span className="inline-flex items-center text-sm text-primary">
          {getLabel(t)}

          <Button variant="link" onClick={() => setReason(null)} className="ml-auto text-xxs">
            {t('change')}
          </Button>
        </span>

        <span className="text-xs text-muted-foreground opacity-50">{getDescription(t)}</span>
      </Column>
    </Row>
  );
}
